module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charges"
  }, [(!_vm.$store.state.loadingDmr) ? _c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Afgiftsdetaljer\n                ")]), _vm._v(" "), (_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer.length > 0) ? _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer), function(charge) {
    return _c('line-data', {
      key: charge.DaekkerFra,
      attrs: {
        "title": charge.AfgiftType,
        "value": charge.Pris,
        "wide": true
      }
    })
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Hyppighed",
      "value": _vm.$store.state.carData.dmr.Afgift.AfgiftDetaljer[0].Hyppighed
    }
  })], 2) : _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Ingen afgiftsdetaljer\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column column__large"
  }, [_c('div', {
    staticClass: "block charges-block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Opkrævede afgifter\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body table"
  }, [(_vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedCharges), function(charge, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "lp"
    }, [_vm._v(_vm._s(charge.RegNr))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.AfgiftType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.DaekkerFra) + " - " + _vm._s(charge.DaekkerTil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.Pris))])])
  }), 0)]) : _c('div', [_vm._v("\n                        Der er endnu ikke opkrævet afgifter på dette køretøj.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block charges-block-mobile"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Opkrævede afgifter\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body table"
  }, [(_vm.$store.state.carData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('div', _vm._l((_vm.sortedCharges), function(charge, index) {
    return _c('div', {
      key: index,
      staticClass: "single-charge"
    }, [_c('line-data', {
      attrs: {
        "title": "Reg.Nr.",
        "value": charge.RegNr
      }
    }), _vm._v(" "), _c('line-data', {
      attrs: {
        "title": "Type",
        "value": charge.AfgiftType
      }
    }), _vm._v(" "), _c('line-data', {
      attrs: {
        "title": "Periode",
        "value": charge.DaekkerFra + ' - ' + charge.DaekkerTil
      }
    }), _vm._v(" "), _c('line-data', {
      attrs: {
        "title": "Pris",
        "value": charge.Pris
      }
    }), _vm._v(" "), (index !== _vm.sortedCharges.length - 1) ? _c('hr') : _vm._e()], 1)
  }), 0) : _c('div', [_vm._v("\n                        Der er endnu ikke opkrævet afgifter på dette køretøj.\n                    ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Reg.nr.")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Dækker fra - til")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Pris")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-368c1528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/pages/charges.vue
// module id = 350
// module chunks = 1